import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-analysis-discharges',
  templateUrl: './analysis-discharges.component.html',
  styleUrls: ['./analysis-discharges.component.css']
})

export class AnalysisDischargesComponent implements OnInit {

  lst_Result: any[] = [];

  lst_Search: any = [];

  list_Tanker: any = [];

  lst_Analyze: any = [];

  lst_Search_Analyze: any = [];

  bMap: boolean = false;

  obj_Report = {

    MergeCount: 0,

    TotalDischarge: 0,

  }

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().subtract(30, 'day').format('jYYYY/jMM/jDD'), Validators.required),

    strEDate: new FormControl('', Validators.required),

    strUnitID: new FormControl(''),

    iRadiusMeters: new FormControl('20', Validators.required),

    iMaxAllowableDischarge: new FormControl('2000', Validators.required),

    fLon: new FormControl(''),

    fLat: new FormControl(''),


  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    // this.mdl_Search.patchValue({

    //   strSDate: '1403/03/12',

    //   strEDate: '1403/03/13',

    // });

    // this.get_Analysis();

    this.getTanker();

  }

  filter_list(val: any) {

    // this.lst_Trips = this.lst_Search.filter((el: any) => {

    //   return el?.strSystemUser_FullName?.includes(val.value) ||

    //     el.iEmdadRo?.toString().includes(val.value) ||

    //     el.strTaxiLon_TripStatus_strComment?.toString().includes(val.value) ||

    //     el.strSCityName?.includes(val.value) ||

    //     el.strFullName?.includes(val.value) ||

    //     el.strMobile?.includes(val.value) ||

    //     el.strDriver_Mobile?.includes(val.value) ||

    //     el.strDriver_FullName?.includes(val.value)

    // });

    // if (val.value.trim() == '') {

    //   this.lst_Trips = this.lst_Search;

    // }

  }

  async getTanker() {

    this._otherService.Showspinner()

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post('Tanker_List', this._otherService.stringNumberToNumber(model))).data.toString());

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '14' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._otherService.nonespinner()

    this.list_Tanker = res;

  }

  async get_Analysis() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    if (this.mdl_Search.get('iRadiusMeters')?.value < 5) {

      return this._tooltip.showError('شعاع تخلیه نمی تواند کمتر از 5 باشد');

    }

    if (this.mdl_Search.get('iMaxAllowableDischarge')?.value < 1) {

      return this._tooltip.showError('حداکثر تخلیه مجاز نمی تواند کمتر از 1 باشد');

    }

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Tanker_TotalDischargeAnalysis`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dsxsdsdwe21110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Result = res;

    this.lst_Search = res;

    this.obj_Report = {

      MergeCount: 0,

      TotalDischarge: 0,

    }

    this.lst_Result.forEach((el: any) => {

      this.obj_Report.MergeCount += el.MergeCount;

      this.obj_Report.TotalDischarge += el.TotalDischarge;

    })

  }

  async openBubbleMap() {

    window.localStorage.setItem("bubbleMap_date", this.gurdService.encrypt(JSON.stringify(this.lst_Search)));

    window.open('/tanker/analysis-discharges/map', '_blank')

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'تحلیل تخلیه ها.xlsx');

    }, 200);

  }

  async openInfo(item: any) {

    let model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      striTanker_Discharges: item.striTanker_Discharges

    }

    this._otherService.Showspinner()

    let res = JSON.parse((await axios.post(`Tanker_DischargeAnalyze_Info`, this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Analyze = res;

    this.lst_Search_Analyze = res;

    $("#view_Modal").modal("show");


  }

  showOnMap = async (item: any) => {

    this.bMap = false;

    setTimeout(() => {

      this.mdl_Search.patchValue({

        fLon: item.CenterLon,

        fLat: item.CenterLat,

      })

      this.bMap = true;

    }, 10);


  }

  filter_Analyze(val: any) {

    this.lst_Analyze = this.lst_Search_Analyze.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strAddress.includes(val.value) ||

        el.strDate.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Analyze = this.lst_Search_Analyze;

    }

  }


}
